<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">

                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("centro-custo") }}:
                            {{
                                descricao || $t("novo")
                            }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t($route.meta.contexto) }}
                                    </a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t("financeiro") }}</a>
                                </li>
                                <li>
                                    <a 
                                        @click="$router.push(
                                            { name: `${$route.meta.abrev}-centro-custo-list` }
                                        )"
                                    >
                                        {{ $t("centro-custo") }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{ $t("gerenciar") }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <!-- BOTÕES -->
                    <div class="header-buttons">
                        <button
                            class="delete-btn" 
                            type="button" 
                            @click="redirectToPage">
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>
                <ul class="nav nav-tabs nav-tabs-children" v-if="isUpdate">
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>
                <!-- CONJTO DE ABAS - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ $t(abas[abaSelecionada]) }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        {{ $t(aba) }}
                    </b-dropdown-item>
                </b-dropdown>

                <Geral
                    ref="tabGeral"
                    v-show="abas[abaSelecionada] == 'geral'"
                    :isUpdate="isUpdate"
                    @isChanged="isChanged = $event"
                    @descricao="descricao = $event"
                />
                <Usuario
                    ref="tabUsuario"
                    v-if="
                        abasAbertas['usuario'] &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'usuario'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

// Abas
import Geral from "@/components/vendas/financeiro/centro-custo/abas/Geral";
import Usuario from "@/components/vendas/financeiro/centro-custo/abas/Usuario";

export default {
    components: {
        Geral,
        Usuario
    },
    data() {
        return {
            abaSelecionada: 0,
            // Seguir nome na tabela app_tela e usar estes nomes no dicionário para criação dinâmica de listaPermissoes e abasAbertas
            abas: [
                "geral",
                "usuario"
            ],
            abasAbertas: {},
            isUpdate: false,
            isChanged: false,
            descricao: null,
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
    },
    created() {
        if (this.$route.meta.contexto == "vendas") {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "financeiro",
                "ven-centro-custo"
            );
        } else if (this.$route.meta.contexto == "despesas") {
            this.permissao = this.hasPermissionAccess(
                "despesas",
                "cadastros",
                "des-centro-custo"
            );
        }

        !this.permissao.read && this.$router.push({
            name: 'acesso-nao-permitido',
            params: { tela: 'centro-custo' },
        });

        if (this.$route.params.id && this.$route.params.name != `${this.$route.meta.abrev}-centro-custo-new`) {
            this.isUpdate = true;
        }

    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        showMessageFromTab(data) {
            this.$root.showMessage(data.type, data.message);
        },
        redirectToPage() {
            let tempTela = `${this.$route.meta.abrev}-centro-custo-list`;;
            let tempAba = null;
            
            const route = {
                    name: tempTela,
                    params: { id: this.$route.query['id'] },
                    query: { abaSelecionada: tempAba },
                }
            setTimeout(() => {
                this.$router.push(route);
            }, 1000);
    },
}
};
</script>
<style lang="scss" scoped>
    #main {
        padding: 0 20px;
        height: 100%;
    
        .page {
            position: relative;
            padding-left: 0;
    
            .nav-tabs-main {
                margin-bottom: 10px;
            }
            .nav-tabs-children {
                margin-bottom: 20px;
                li > a {
                    text-transform: capitalize;
                }
                li > ::after {
                    bottom: -4px;
                    border-width: 2px;
                }
            }
    
            .mobile-tab {
                cursor: pointer;
    
                &-list {
                    width: calc(100% + 40px);
                    margin-top: 20px;
                    margin-bottom: 20px;
                    margin-left: -20px;
                    padding-right: 20px;
                    padding-bottom: 5px;
                    padding-left: 20px;
                    border-bottom: 1px solid $table-border;
                    justify-content: center;
    
                    &::after {
                        content: "";
                        border: 3px solid $primary-color-click;
                        border-radius: 100px;
                        position: absolute;
                        width: calc(100% - 40px);
                        bottom: -3px;
                    }
    
                    &-item {
                        text-transform: uppercase;
                        font-weight: 600;
                        color: $text-color;
    
                        &.active {
                            color: $primary-color-click;
                        }
                    }
                }
    
                &-text {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $primary-color-click;
    
                    & ~ i {
                        color: $primary-color-click;
                    }
                }
            }
        }
    }
    
    @media only screen and (max-width: 760px) {
        .nav.nav-tabs-main {
            display: flex;
            justify-content: center;
            padding: 0;
            margin: 0;
    
            &::after {
                display: none;
            }
        }
    
        .nav.nav-tabs.nav-tabs-children {
            display: none;
        }
    }
    
    @media only screen and (min-width: 761px) {
        .mobile-tab-list {
            display: none;
        }
    }
</style>
